const actualizarDespacho = async (idDespacho, elegido, facturado) => {
  console.log(`[MOCK] Simulando actualización de despacho: ${idDespacho}, elegido: ${elegido}, facturado: ${facturado}`);

  // Simular un delay realista
  await new Promise(resolve => setTimeout(resolve, 500));

  // Devolver respuesta simulada exitosa
  return {
    success: true,
    message: "Despacho actualizado correctamente (SIMULADO)",
    data: {
      idDespacho: idDespacho,
      elegido: elegido,
      facturado: facturado,
      timestamp: new Date().toISOString(),
    },
  };
};

const estadoDespachoAPI = { actualizarDespacho };

export default estadoDespachoAPI;
